module.exports = __webpack_public_path__ + "static/tech_hapi-0774e53e8b01022b097edb5f98291cb4.svg";